import React, { createContext, useContext, useState } from "react";
import { translations } from "../translations/translations";

type Lang = "pt" | "en";

interface LanguageContextProps {
  lang: Lang;
  setLang: React.Dispatch<React.SetStateAction<Lang>>;
  t: typeof translations["pt"];
}

const LanguageContext = createContext<LanguageContextProps | undefined>(undefined);

export const LanguageProvider = ({ children }: { children: React.ReactNode }) => {
  const [lang, setLang] = useState<Lang>("pt");
  const t = translations[lang];
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used inside a LanguageProvider");
  }
  return context;
};
